import Default from './DefaultTemplate'
import KsuOne from './KsuOneTemplate'
import KsuTwo from './KsuTwo'
import KsuThree from './KsuThree'
export default {
	Default,
	KsuOne,
	KsuTwo,
	KsuThree
}